var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "ShoppingCartMobile form-wrapper",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.proceedPayment($event)
        }
      }
    },
    [
      _c("div", { staticClass: "m-0 p-0 form-wrapper-body" }, [
        _c("h3", [_vm._v("Invoice")]),
        _vm._v(" "),
        _c("div", { staticClass: "basket flex-grow-1" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "basket-body row mx-0" },
            [
              _c(
                "div",
                { staticClass: "row mx-0" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-8 fisrt-section",
                      attrs: { title: _vm.invoiceData.activityName }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "text-gray",
                          style: { fontSize: "13px" }
                        },
                        [_vm._v("\n            Activity\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "cursor-pointer activity-name text-truncate"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.invoiceData.activityName) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.invoiceData.amount !== 0
                    ? [
                        _c(
                          "div",
                          {
                            class: [
                              "col-4",
                              "pt-3",
                              "second-section",
                              "base-price"
                            ]
                          },
                          [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("currencySign")(_vm.schoolCurrency)
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("priceFormat")(
                                      _vm.invoiceData.amount
                                    )
                                  ) +
                                  " "
                              ),
                              _vm.showBillingRate
                                ? _c("span", [
                                    _vm._v(
                                      "/ " +
                                        _vm._s(
                                          _vm._f("toCapitalize")(
                                            _vm.invoiceData
                                              .aftercareActivityDetails
                                              .billingRate
                                          )
                                        )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      ]
                    : [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-4 pt-3 text-green second-section d-flex justify-content-center align-items-end"
                          },
                          [_vm._v("\n            FREE\n          ")]
                        )
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _vm.invoiceData.addons
                ? _c("div", { staticClass: "row mx-0" }, [
                    _c(
                      "div",
                      { staticClass: "col-8 pl-0" },
                      _vm._l(_vm.invoiceData.addons, function(addon) {
                        return _c("div", { staticClass: "addon-chip" }, [
                          _c("span", [
                            _vm._v(
                              "Addon: " +
                                _vm._s(
                                  _vm._f("currencySign")(_vm.schoolCurrency)
                                ) +
                                _vm._s(addon.amount)
                            )
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "col-4 second-section round-top-border align-items-center"
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row mx-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-8 fisrt-section",
                    attrs: {
                      title:
                        _vm.invoiceData.child.firstName +
                        " " +
                        _vm.invoiceData.child.lastName
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "text-gray mb-2",
                        style: { fontSize: "13px" }
                      },
                      [_vm._v("Child")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("div", { staticClass: "name text-truncate" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.invoiceData.child.firstName +
                                " " +
                                _vm.invoiceData.child.lastName
                            ) +
                            "\n            "
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 second-section" })
              ]),
              _vm._v(" "),
              _vm.invoiceData.aftercareActivityDetails &&
              _vm.invoiceData.aftercareActivityDetails.daysOfWeek
                ? [
                    _c("div", { staticClass: "row mx-0" }, [
                      _c("div", { staticClass: "col-8 fisrt-section" }, [
                        _c(
                          "p",
                          {
                            staticClass: "text-gray mb-2",
                            style: { fontSize: "13px" }
                          },
                          [
                            _vm._v(
                              "\n                                Days\n                            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "name" },
                          _vm._l(
                            _vm.invoiceData.aftercareActivityDetails.daysOfWeek,
                            function(day, index) {
                              return _c(
                                "span",
                                { key: index, staticClass: "day" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm._f("toCapitalize")(day.dayOfWeek)
                                      ) +
                                      "\n                                "
                                  )
                                ]
                              )
                            }
                          ),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-4 second-section" })
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.invoiceData.aftercareDropInDetails &&
              _vm.invoiceData.aftercareDropInDetails.dropInDates
                ? [
                    _c("div", { staticClass: "row mx-0" }, [
                      _c("div", { staticClass: "col-8 fisrt-section" }, [
                        _c(
                          "p",
                          {
                            staticClass: "text-gray mb-2",
                            style: { fontSize: "13px" }
                          },
                          [
                            _vm._v(
                              "\n                                Dates\n                            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "date-wrapper" },
                          _vm._l(
                            _vm.invoiceData.aftercareDropInDetails.dropInDates,
                            function(date, index) {
                              return _c(
                                "span",
                                { key: index, staticClass: "date-chip" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(date.date) +
                                      "\n                                "
                                  )
                                ]
                              )
                            }
                          ),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-4 second-section" })
                    ])
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "basket-footer" },
            [
              !(_vm.isScheduledAttendance || _vm.isActualAttendance)
                ? [
                    _c(
                      "div",
                      { staticClass: "row mx-0" },
                      [
                        _c("p", { staticClass: "col-8 fisrt-section-result" }, [
                          _vm._v("Total:")
                        ]),
                        _vm._v(" "),
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "col-4 py-2 mb-0 second-section text-right"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("currencySign")(_vm.schoolCurrency)
                                  ) +
                                  " " +
                                  _vm._s(_vm.invoiceData.totalActivityPrice) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      ],
                      2
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.showTotalAddons
                ? [
                    _c(
                      "div",
                      { staticClass: "row mx-0" },
                      [
                        _c(
                          "p",
                          { staticClass: "col-8 fisrt-section-result " },
                          [_vm._v("Total Addons:")]
                        ),
                        _vm._v(" "),
                        [
                          _c(
                            "p",
                            { staticClass: "col-4 py-2 mb-0 second-section" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("currencySign")(_vm.schoolCurrency)
                                  ) +
                                  " " +
                                  _vm._s(_vm.invoiceData.totalAddon) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      ],
                      2
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.invoiceData.discounts.length > 0
                ? [
                    _vm._l(_vm.discounts, function(discount) {
                      return [
                        _c(
                          "div",
                          { staticClass: "row mx-0" },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "col-8 py-2 mb-0 fisrt-section-result"
                              },
                              [_vm._v(_vm._s(discount.label) + ":")]
                            ),
                            _vm._v(" "),
                            [
                              _c(
                                "p",
                                {
                                  class: [
                                    "col-4",
                                    "py-2",
                                    "mb-0",
                                    "second-section",
                                    "red-color"
                                  ]
                                },
                                [
                                  _vm.isActualAttendance
                                    ? _c("span", [
                                        _vm._v(
                                          "-" + _vm._s(discount.value) + "%"
                                        )
                                      ])
                                    : _vm.isScheduledAttendance
                                    ? _c("span", [
                                        _vm._v(
                                          "-" +
                                            _vm._s(
                                              _vm._f("currencySign")(
                                                _vm.schoolCurrency
                                              )
                                            ) +
                                            " " +
                                            _vm._s(discount.amount) +
                                            " /" +
                                            _vm._s(_vm.isDay)
                                        )
                                      ])
                                    : _c("span", [
                                        discount.amount > 0
                                          ? _c("span", [
                                              _vm._v(
                                                "- " +
                                                  _vm._s(
                                                    _vm._f("currencySign")(
                                                      _vm.schoolCurrency
                                                    )
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm._f("priceFormat")(
                                                      discount.amount
                                                    )
                                                  )
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("currencySign")(
                                                    _vm.schoolCurrency
                                                  )
                                                ) + " 0"
                                              )
                                            ])
                                      ])
                                ]
                              )
                            ]
                          ],
                          2
                        )
                      ]
                    })
                  ]
                : [
                    _c("div", { staticClass: "row mx-0" }, [
                      _c("p", { staticClass: "col-8 fisrt-section-result " }, [
                        _vm._v("Discount:")
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { class: ["col-4", "py-2", "mb-0", "second-section"] },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("currencySign")(_vm.schoolCurrency)
                              ) + " 0"
                            )
                          ])
                        ]
                      )
                    ])
                  ],
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row mx-0" },
                [
                  _c("p", { staticClass: "col-8 fisrt-section-result " }, [
                    _vm._v("Coupon:")
                  ]),
                  _vm._v(" "),
                  _vm.invoiceData.coupon
                    ? [
                        _c(
                          "p",
                          {
                            class: [
                              "col-4",
                              "py-2",
                              "mb-0",
                              "second-section",
                              "red-color"
                            ]
                          },
                          [
                            _vm.isActualAttendance || _vm.isScheduledAttendance
                              ? _c("span", [
                                  _vm.invoiceData.coupon.couponType ===
                                  "FIXED_AMOUNT"
                                    ? _c("span", [
                                        _vm._v(
                                          "-" +
                                            _vm._s(
                                              _vm._f("currencySign")(
                                                _vm.schoolCurrency
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm._f("priceFormat")(
                                                _vm.invoiceData.coupon.value
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.invoiceData.coupon.couponType ===
                                  "PERCENTAGE"
                                    ? _c("span", [
                                        _vm._v(
                                          "-" +
                                            _vm._s(
                                              _vm._f("priceFormat")(
                                                _vm.invoiceData.coupon.amount
                                              )
                                            ) +
                                            "%"
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              : _c("span", [
                                  _vm.invoiceData.coupon.value > 0
                                    ? _c("span", [
                                        _vm._v(
                                          "- " +
                                            _vm._s(
                                              _vm._f("currencySign")(
                                                _vm.schoolCurrency
                                              )
                                            ) +
                                            _vm._s(
                                              _vm._f("priceFormat")(
                                                _vm.invoiceData.coupon.value
                                              )
                                            )
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("currencySign")(
                                              _vm.schoolCurrency
                                            )
                                          ) + "  0"
                                        )
                                      ])
                                ])
                          ]
                        )
                      ]
                    : [
                        _c(
                          "p",
                          { staticClass: "col-4 py-2 mb-0 second-section" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("currencySign")(_vm.schoolCurrency)
                                ) +
                                " 0\n          "
                            )
                          ]
                        )
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row mx-0" }, [
                _c(
                  "p",
                  { staticClass: "col-8 fisrt-section-result total-bold" },
                  [_vm._v("\n          Billed Today:\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "col-4 py-2 mb-0 second-section round-bottom-border total-bold "
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("currencySign")(_vm.schoolCurrency)) +
                        "\n          "
                    ),
                    _vm.invoiceData.total > 0
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("priceFormat")(_vm.invoiceData.total))
                          )
                        ])
                      : _c("span", [_vm._v("0")])
                  ]
                )
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "promo" },
            [
              _c("p", { staticClass: "text-gray mb-1" }, [
                _vm._v("Apply promo code")
              ]),
              _vm._v(" "),
              _c("app-input", {
                style: { width: "100%" },
                attrs: {
                  type: "text",
                  id: "promocode",
                  placeholder: "Enter promotional code",
                  "blue-button": "",
                  "show-button": !!_vm.couponCode,
                  append: {
                    text: "Apply",
                    width: 80,
                    fontSize: 18,
                    callback: _vm.applyPromocode
                  }
                },
                model: {
                  value: _vm.couponCode,
                  callback: function($$v) {
                    _vm.couponCode = $$v
                  },
                  expression: "couponCode"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "p-3" },
          [
            _c(
              "checkbox",
              {
                attrs: {
                  "checkbox-id": "agree",
                  "blue-color": true,
                  checked: _vm.checked
                },
                on: {
                  "update:checked": function($event) {
                    _vm.checked = $event
                  }
                }
              },
              [
                _vm._v(
                  "\n      I agree to all " +
                    _vm._s(_vm.schoolName) +
                    " policies\n    "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-wrapper-footer" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "spinner",
                rawName: "v-spinner",
                value: _vm.isLoading,
                expression: "isLoading"
              }
            ],
            staticClass: "primary-btn btn-center",
            attrs: { disabled: !_vm.checked || _vm.isLoading }
          },
          [_vm._v("\n    Submit\n  ")]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "basket-header row mx-0" }, [
      _c("div", { staticClass: "col-8" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-4 second-section round-top-border align-items-center"
        },
        [_c("p", { staticClass: "basket-header-title" }, [_vm._v("AMOUNT")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-603ffdb7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-603ffdb7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/PayNowInvoiceModal.vue
// module id = null
// module chunks = 